<template>
  <div class="item-box-content">
    <el-row>
      <el-col :span="12">
        <div class="title-font-style">
          <span>产品清单</span>
        </div>
      </el-col>
      <el-col :span="12" style="text-align:right;">
        <el-button
          v-if="contractOverview.signState===1"
          @click="onBatchSetRemind"
          type="primary"
          plain
        >批量设置提醒</el-button>
        <el-checkbox
          v-model="checked"
          style="padding-left:20px;"
          @change="onOpenExtime"
        >开启货期提醒，到达约定时间后发送站内消息</el-checkbox>
      </el-col>
    </el-row>
    <div class="product-list-box">
      <div>
        <!-------------- 期货期款列表 -------------->
        <futures-payment-table
          :productList="productList"
          @onFuturesCheckList="onFuturesCheckList"
          ref="futuresPaymentTableRefs"
          :futuresPaymentList="futuresPaymentTable"
          :goodAmountPer="goodAmountPer"
          :goodAmount="goodAmount"
          @getParentData="getParentData"
          :contractOverview="contractOverview"
          v-show="boolSetFutres"
        ></futures-payment-table>
        <el-table
          max-height="378"
          v-show="!boolSetFutres"
          ref="custromTableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column fixed type="selection"></el-table-column>
          <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
          <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column label="型号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onProductDetail(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="订货号" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cbNumber" label="数量"></el-table-column>
          <el-table-column prop="cbUnit" label="单位"></el-table-column>
          <el-table-column label="货期" width="110">
            <template slot-scope="scope">
              <el-row :gutter="5" v-if="contractOverview.signState===1">
                <el-col :span="20">
                  <el-input
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    v-model="scope.row.cbExtimeValue"
                  ></el-input>
                </el-col>
                <el-col :span="4">天</el-col>
              </el-row>
              <span v-else>{{scope.row.cbExtimeValue}}天</span>
            </template>
          </el-table-column>
          <el-table-column width="125" label="提醒">
            <template slot-scope="scope">
              <span
                class="approval"
                @click="cbRemindSet(scope.$index)"
                v-if="contractOverview.signState===1"
              >{{scope.row.cbRemind||'请设置提醒时间'}}</span>
              <span v-else>{{ scope.row.cbRemind|dateFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cbPrice" label="销售单价">
            <template slot-scope="scope">{{ scope.row.cbPrice | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="cbDiscount" label="折扣">
            <template slot-scope="scope">{{ scope.row.cbDiscount | perCentFilter }}</template>
          </el-table-column>
          <el-table-column prop="cbRate" label="毛利率" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cbRate | perCentFilter }}</template>
          </el-table-column>
          <el-table-column prop="cbTotal" label="销售总额">
            <template slot-scope="scope">{{ scope.row.cbTotal | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="cbUnitPrice" label="供货单价">
            <template slot-scope="scope">{{ scope.row.cbUnitPrice | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="cbUnitTotal" label="供货总价">
            <template slot-scope="scope">{{ scope.row.cbUnitTotal | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="mark" label="备注" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="cbFacePrice" label="面价">
            <template slot-scope="scope">{{ scope.row.cbFacePrice | priceFilter }}</template>
          </el-table-column>
          <el-table-column label="询价来源">
            <template
              slot-scope="scope"
            >{{scope.row.cbPriceSource===4?'其他':scope.row.cbPriceSource===2?'人工':scope.row.cbPriceSource===3?'特价审批':scope.row.cbPriceSource===1?'系统':'库存'}}</template>
          </el-table-column>
        </el-table>
      </div>
      <p class="totNum">总计</p>
      <el-table
        ref="productsEnquiryTableRefs"
        :data="productListTotal"
        stripe
        border
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTotalTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="contractKind" label="产品种类"></el-table-column>
        <el-table-column prop="contractTotal" label="报价总额">
          <template slot-scope="scope">{{ scope.row.contractTotal | priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="contractCost" label="供货成本">
          <template slot-scope="scope">{{ scope.row.contractCost | priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="contractRate" label="毛利率">
          <template slot-scope="scope">{{ scope.row.contractRate | perCentFilter }}</template>
        </el-table-column>
      </el-table>
    </div>
    <!------------ 设置提醒 ------------>
    <batch-set-remindDialog
      ref="batchSetRemindDialogRefs"
      @onSetTime="onSetTime"
      @onSetTimeAll="onSetTimeAll"
    ></batch-set-remindDialog>
  </div>
</template>
<script>
import batchSetRemindDialog from '@/components/SetReminders/batchSetRemindDialog'
import futuresPaymentTable from './futuresPaymentTable'
import { updateByIsOpenExtime } from '@/api/sell/sellManage'
export default {
  props: [
    'isSetFutures',
    'productList',
    'futuresPaymentTable',
    'productListTotal',
    'goodAmountPer',
    'goodAmount',
    'isOpenExtime',
    'contractOverview'
  ],
  components: {
    'batch-set-remindDialog': batchSetRemindDialog,
    'futures-payment-table': futuresPaymentTable
  },
  data() {
    return {
      checked: false,
      loadingTable: false, // 列表loading
      loadingTotalTable: false,
      boolSetFutres: false,
      futuresPaymentList: [], // 期货期款产品清单
      title: '设置期货', // 设置期货弹窗标题
      list: [], // 产品清单(除了期货期款的列表)
      checkList: [], // 产品清单选中列表数据(除了期货期款的列表)
      paymentType: 0, // 付款类型:期货期款是1,其他类型是0
      changeList: [], // 期货期款改变之后的产品清单
      futuresList: [], // 期货列表
      timeChange: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 选择时间范围
        }
      }
    }
  },
  watch: {
    // 除了期货期款的产品清单
    productList: {
      handler(newVal) {
        if (newVal) {
          this.list = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true
    },
    isSetFutures: {
      handler(newVal) {
        this.boolSetFutres = JSON.parse(JSON.stringify(newVal))
      },
      deep: true
    },
    isOpenExtime: {
      handler(newVal) {
        if (newVal) {
          this.checked = Boolean(newVal)
        }
      }
    }
  },
  methods: {
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    onOpenExtime() {
      // 开启货期提醒
      if (this.contractOverview.signState !== 1) {
        updateByIsOpenExtime(this.$route.query.id, Number(this.checked))
      }
    },
    // 列表数据选中
    handleSelectionChange(row) {
      this.checkList = row
    },
    cbRemindSet(index) {
      // 设置提醒时间 显示 弹框
      this.$refs.batchSetRemindDialogRefs.onInitial(index)
    },
    // 批量设置提醒
    onBatchSetRemind() {
      if (this.paymentType !== 1) {
        // 非期货产品清单
        if (this.checkList.length > 0) {
          this.$refs.batchSetRemindDialogRefs.onInitial('all')
        } else {
          this.$message.error('请选择数据')
        }
      } else {
        // 期货设置产品清单
        let num = 0
        this.futuresList.forEach((item) => {
          item.orderShipmentQueryVoList.forEach((res) => {
            if (res.isBool) {
              num += 1
            }
          })
        })
        if (num > 0) {
          this.$refs.batchSetRemindDialogRefs.onInitial('all')
        } else {
          this.$message.error('请选择数据')
        }
      }
    },
    onSetTime(val, i) {
      // 非期货期款 设置提醒
      if (!this.list[i].cbExtimeValue) {
        this.$message.error('请设置货期')
      } else {
        this.list[i].cbRemind = val
      }
    },
    onSetTimeAll(val) {
      // 批量设置提醒
      if (this.paymentType === 1) {
        this.$refs.futuresPaymentTableRefs.onSetReminders(val)
      } else {
        let isF = false
        this.list.forEach((item, index) => {
          this.checkList.forEach((ele) => {
            if (item.id === ele.id) {
              if (item.cbExtimeValue) {
                item.cbRemind = val
              } else {
                isF = true
              }
            }
          })
        })
        if (isF) {
          this.$message.error('请设置货期')
        }
      }
    },
    // 期货期款列表选择后提醒
    onFuturesCheckList(arr) {
      this.futuresList = arr
      this.paymentType = 1
    },
    onEventBus() {
      this.$refs.futuresPaymentTableRefs.onChildData()
    },
    getParentData(list, show) {
      this.$emit('getParentDataMax', list, show)
    }
  }
}
</script>
<style lang="scss" scoped>
.product-list-box {
  padding: 20px 0;
  .product-list-box-set-futures {
    height: 140px;
    background: rgba(243, 247, 255, 1);
    border-radius: 4px;
  }
}
.totNum {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0 14px;
}
</style>
